import { Handle } from '@xyflow/react';

export default function BhHandle({ mode = 'fixed', glyph = null, className = '', ...handleProps }) {
  const cls = `bh-handle bh-handle-${mode}${className ? ' ' + className : ''}`;
  return (
    <Handle className={cls} {...handleProps}>
      {glyph ? <span className="bh-handle-glyph">{glyph}</span> : null}
    </Handle>
  );
}
